export class WineItem {
    name: string;
    active: boolean;
    organic; boolean;
    description: string;
    image: {
        url: string;
    };
    alcohol: number;
    acid: number;
    year: number;
    category: {
        name: string
    }
}
